import { useState } from 'react';

import { TabScreenWrapper } from '@components/General/TabScreen';
import { Flap } from '@models/Flap';
import { Organization } from '@models/Organization';
import { AltaComunicacionesGeneral } from '@components/Comunicaciones/AltaComunicacionGeneral';
import { Solicitudes } from '@components/Solicitudes/Solicitudes';
import Consultas from '@components/Solicitudes/Consultas';

interface SolicitudesScreenProps {
    org: Organization;
}

const SolicitudesScreen = ({org}: SolicitudesScreenProps) => {

    const [clickedScreen, setClickedScreen] = useState<string>('licencias')

    const flaps: Flap[] = [
        { 
            id: 'licencias', 
            label: 'Licencias', 
            content: <Solicitudes orgID={org.id} timezone={org.timezone}/> 
        },
        { 
            id: 'consultas', 
            label: 'Consultas', 
            content: <Consultas orgID={org.id}/> 
        },
    ];

    return (
        <TabScreenWrapper
            title="Solicitudes"
            subtitle="Gestión de solicitudes realizadas por los colaboradores"
            flaps={flaps}
            flag={org.newFlags.RequestsWeb}
            clickedScreen={clickedScreen}
            setClickedScreen={setClickedScreen}
        />
    );
};

export default SolicitudesScreen
